import React from 'react';
import { ObjectDetailsSpacer } from '@atlassian/jira-servicedesk-insight-attribute-views/src/common/ui/styled.tsx';
import { OpsgenieTeamsReadView } from '@atlassian/jira-servicedesk-insight-attribute-views/src/ui/opsgenie-team/index.tsx';
import { getOpsgenieTeamValues } from '@atlassian/jira-servicedesk-insight-object-attribute-utils/src/utils/opsgenie-team/index.tsx';
import { useEditableAttribute } from '@atlassian/jira-servicedesk-insight-object-details-store/src/controllers/use-editable-attribute/index.tsx';
import type { OpsgenieTeamAttributeType } from '@atlassian/jira-servicedesk-insight-object-types/src/common/types/object-attribute-type.tsx';
import type { OpsgenieTeam } from '@atlassian/jira-servicedesk-insight-object-types/src/common/types/object-details.tsx';
import { InlineEditableAttribute } from '../../common/ui/editable-attribute/index.tsx';

export interface Props {
	isEditable: boolean;
	attributeType: OpsgenieTeamAttributeType;
}

export const toFieldValue = (repos: OpsgenieTeam[]) => repos.map(({ id }) => id);

export const OpsgenieTeamsAttribute = (props: Props) => {
	const { attributeType } = props;
	const [{ attribute }] = useEditableAttribute(attributeType);
	const value = getOpsgenieTeamValues(attribute);
	const storedValue = toFieldValue(getOpsgenieTeamValues(attribute));

	return (
		<InlineEditableAttribute
			testId="servicedesk-insight-inline-editable-attributes.ui.opsgenie-team-attribute.opsgenie-team-attribute"
			value={toFieldValue(value)}
			storedValue={storedValue}
			attributeType={props.attributeType}
			isEditable={props.isEditable}
			attributeValuesInfo={{ type: 'opsgenieTeam', attributeValues: value }}
			scalingEnabled
			renderReadView={() => (
				<ObjectDetailsSpacer>
					<OpsgenieTeamsReadView opsgenieTeams={value} showPlaceholderIfEmpty />
				</ObjectDetailsSpacer>
			)}
			renderEditView={() => /* OpsGenie Team is only readonly at present */ <></>}
			// eslint-disable-next-line @typescript-eslint/no-empty-function
			onResetValue={() => {}}
		/>
	);
};
